import styled from 'styled-components';
import { AppBar as MuAppBar, Box, Menu } from '@mui/material';
import Button from '../../../atoms/Button';
import Avatar from '../../../atoms/Avatar';
export var LogoContainer = styled.div.withConfig({
  displayName: "style__LogoContainer",
  componentId: "sc-108iku0-0"
})(["flex:1;display:flex;align-items:center;"]);
export var SearchIconBox = styled(Box).withConfig({
  displayName: "style__SearchIconBox",
  componentId: "sc-108iku0-1"
})(["&&{background-color:", ";margin-left:20px;padding:10px;border-radius:50%;display:flex;justify-content:center;align-items:center;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.red[300];
});
export var AppBar = styled(MuAppBar).withConfig({
  displayName: "style__AppBar",
  componentId: "sc-108iku0-2"
})(["&&{", "}a{text-decoration:none;&:hover{text-decoration:none;}}"], function (_ref2) {
  var haselevation = _ref2.haselevation;
  return !haselevation && "box-shadow: none;";
});
export var UserButton = styled(Button).withConfig({
  displayName: "style__UserButton",
  componentId: "sc-108iku0-3"
})(["&&{border-radius:25px;padding-left:5px;padding-right:10px;background-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme && theme.red[400];
});
export var UserAvatar = styled(Avatar).withConfig({
  displayName: "style__UserAvatar",
  componentId: "sc-108iku0-4"
})(["&&{padding:0;margin-right:10px;}"]);
export var StyledMenu = styled(Menu).withConfig({
  displayName: "style__StyledMenu",
  componentId: "sc-108iku0-5"
})(["&&{top:45px !important;left:0 !important;right:20px !important;}"]);